import React from 'react';
import PropTypes from 'prop-types';
import colors from '@general/colors';

const CaretDownIcon = ({ color = colors.black }) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M3.5 6.5L8 11L12.5 6.5"
                stroke={color}
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

CaretDownIcon.propTypes = {
    color: PropTypes.string,
};

export default CaretDownIcon;
